export default {"src":"/_next/static/media/SubDesc1.eea333f5.svg","height":201,"width":200,"blurWidth":0,"blurHeight":0};